import { ReactNode } from 'react';
import clsx from 'clsx';

type Variant = 'display' | 'title' | 'heading' | 'body' | 'small' | 'micro' | 'label';

const styles: Record<Variant, string> = {
  display: 'text-2xl font-semibold tracking-tighter',
  title:   'text-xl font-semibold tracking-tight',
  heading: 'text-lg font-semibold tracking-tight',
  body:    'text-base font-normal',
  small:   'text-sm font-normal',
  micro:   'text-xs font-medium uppercase tracking-[0.08em] text-muted',
  label:   'text-xs font-medium text-muted',
};

export function Text({
  as: Tag = 'p',
  variant = 'body',
  className,
  children,
  muted,
  mono,
}: {
  as?: keyof JSX.IntrinsicElements;
  variant?: Variant;
  className?: string;
  children: ReactNode;
  muted?: boolean;
  mono?: boolean;
}) {
  return (
    <Tag className={clsx(styles[variant], muted && 'text-muted', mono && 'tnum', className)}>
      {children}
    </Tag>
  );
}
